import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api, getAuthHeaders } from '../utils/api';

export const deleteAsset = createAsyncThunk(
  "assets/deleteAsset",
  async (assetId, thunkAPI) => {
    await api.delete(`/assets/${assetId}`, { headers: getAuthHeaders() });
    return assetId;
  }
);


// Fetch assets list
export const fetchAssets = createAsyncThunk(
  "assets/fetchAssets",
  async (params = { page: 1, limit: 10, sortBy: "createdAt:desc" }, thunkAPI) => {
    const { page = 1, limit = 10, sortBy = "createdAt:desc" } = params;
    const response = await api.get(
      `/assets?page=${page}&limit=${limit}&sortBy=${sortBy}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  }
);

export const createAsset = createAsyncThunk(
  "assets/createAsset",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/assets",
        payload,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error?.response?.data?.message || 
                 error?.response?.data?.error || 
                 error?.message || 
                 "Failed to create asset"
      });
    }
  }
);

const assetSlice = createSlice({
  name: "assets",
  initialState: {
    loading: false,
    error: null,
    data: null,
    list: [],
    listLoading: false,
    listError: null,
    listMeta: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Delete asset
      .addCase(deleteAsset.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAsset.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally remove the deleted asset from the list
        state.list = state.list.filter(asset => asset.id !== action.payload);
      })
      .addCase(deleteAsset.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Create asset
      .addCase(createAsset.pending, (state) => { state.loading = true; })
      .addCase(createAsset.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createAsset.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Fetch assets list
      .addCase(fetchAssets.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(fetchAssets.fulfilled, (state, action) => {
        state.listLoading = false;
        state.list = action.payload?.results || [];
        state.listMeta = {
          page: action.payload?.page,
          limit: action.payload?.limit,
          totalPages: action.payload?.totalPages,
          totalResults: action.payload?.totalResults,
        };
      })
      .addCase(fetchAssets.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.error.message;
      });
  },
});

export default assetSlice.reducer;
